module.exports = __webpack_public_path__ + "static/metropolitan-water-district-ff910602c86c0ee3063549e3c49571d2.jpg";